import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";

@injectable()
export class ReactInternalChatMessageUseCase {
    private _repository: InternalChatRepository;

    constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
        this._repository = repository;
    }

    public call(messageId: string, reactionId: string, reaction: string): Promise<void> {
        return this._repository.reactMessage(messageId, reactionId, reaction);
    }
}
